<template>
  <div class="rule-form-step rule-form-step--start rule-form-step--start--step-4 flex max-w-4xl flex-col gap-5 py-5">
    <ad-creation-method-block :entity="entity" :disabled="$parent.readonlyMode" />

    <ad-content-sources-block
      v-if="entity.isSalesCampaign"
      :entity="entity"
      :disabled="$parent.readonlyMode"
    />

    <leadgen-form-block
      v-if="entity.isLeadFormAd"
      :entity="entity"
      :disabled="$parent.readonlyMode"
    />

    <cta-block
      v-if="ctaBlockIsVisible"
      :entity="entity"
      :disabled="$parent.readonlyMode"
    />
    <template v-if="siteLinksBlockIsVisible">
      <site-links-block :entity="entity" :disabled="$parent.readonlyMode" />
    </template>

    <tracking-block :entity="entity" :disabled="$parent.readonlyMode" />

    <url-params-block
      v-if="urlParamsBlockIsVisible"
      :entity="entity"
      :disabled="$parent.readonlyMode"
    />
  </div>
</template>

<script>
import { AD_CREATION_METHOD } from '@/consts.js';
import RuleFormStepMixin from '@/mixins/RuleForm/Step.js';
import AdContentSourcesBlock from '@/ui/components/RuleForm/Blocks/AdContentSourcesBlock.vue';
import AdCreationMethodBlock from '@/ui/components/RuleForm/Blocks/AdCreationMethodBlock.vue';
import CtaBlock from '@/ui/components/RuleForm/Blocks/CtaBlock.vue';
import LeadgenFormBlock from '@/ui/components/RuleForm/Blocks/LeadgenFormBlock.vue';
import SiteLinksBlock from '@/ui/components/RuleForm/Blocks/SiteLinksBlock.vue';
import TrackingBlock from '@/ui/components/RuleForm/Blocks/TrackingBlock.vue';
import UrlParamsBlock from '@/ui/components/RuleForm/Blocks/UrlParamsBlock.vue';

export default {
  name: 'StartRuleFormStep4',
  components: {
    AdContentSourcesBlock,
    AdCreationMethodBlock,
    CtaBlock,
    LeadgenFormBlock,
    SiteLinksBlock,
    UrlParamsBlock,
    TrackingBlock,
  },
  mixins: [ RuleFormStepMixin ],
  computed: {
    ctaBlockIsVisible() {
      return !this.entity.isPageLikeCampaign
        && !this.entity.isInstagramProfileVisitCampaign;
    },
    urlParamsBlockIsVisible() {
      return this.ctaBlockIsVisible;
    },
    leadgenFormBlockIsVisible() {
      return this.entity.isLeadFormAd;
    },
    siteLinksBlockIsVisible() {
      return this.entity.settings.ad_creation_method === AD_CREATION_METHOD.CREATIVE
        && this.entity.output_campaign?.isSiteLinksEligible
        && !this.entity.isPageLikeCampaign
        && !this.entity.isInstagramProfileVisitCampaign;
    },
  },
};
</script>
